<template>
  <vs-button class="mr-4" @click="save">Save</vs-button>
</template>

<script>
export default {
  methods:{
    save(){
      console.log('SAVINGGGGG')
    }
  }
}
</script>

<style>

</style>